import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCurrentUser } from '../../../contexts/UserContext';
import { getModulesForStudent } from '../../../services/moduleService';

export default function ContinueLearning() {
  const navigate = useNavigate();
  const currentUser = useCurrentUser();
  const studentId = currentUser?.id || currentUser?._id;

  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    if (!studentId) {
      setModules([]);
      setError('');
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    setError('');
    getModulesForStudent(studentId)
      .then((data) => {
        if (cancelled) return;
        setModules((data?.modules || []).slice(0, 3));
      })
      .catch((err) => {
        if (cancelled) return;
        setModules([]);
        setError(err.message || 'Unable to load modules.');
      })
      .finally(() => {
        if (cancelled) return;
        setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [studentId]);

  return (
    <article className="info-card continue-card" aria-label="Continue learning">
      <div className="info-card-header">
        <p className="eyebrow">Continue learning</p>
      </div>
      <ul className="continue-list">
        {loading && (
          <li className="continue-row">
            <p className="muted-text">Loading modules…</p>
          </li>
        )}
        {!loading && error && (
          <li className="continue-row">
            <p className="error-text">{error}</p>
          </li>
        )}
        {!loading && !error && modules.length === 0 && (
          <li className="continue-row">
            <p className="muted-text">
              {studentId ? 'No modules queued yet.' : 'Enroll in a course to see modules here.'}
            </p>
          </li>
        )}
        {!loading &&
          !error &&
          modules.map((module) => (
            <li key={module._id || module.id} className="continue-row">
              <div>
                <p className="info-title">{module.title}</p>
                <p className="muted-text">
                  {module.subject || 'Module'} · {module.estimatedMinutes || '—'} min
                </p>
              </div>
              <div className="continue-meta">
                <button
                  type="button"
                  className="pill-btn subtle"
                  onClick={() => navigate(`/learn/modules/${module._id || module.id}`)}
                >
                  Open
                </button>
              </div>
            </li>
          ))}
      </ul>
    </article>
  );
}
